import { SignInRequestType } from '../types';
import { UserResponseType } from '../types/user-response-type ';

export function getUser(): Promise<UserResponseType> {
  return new Promise((resolve: (value: PromiseLike<UserResponseType> | UserResponseType) => void) => {
    setTimeout(
      () =>
        resolve({
          username: 'John Smith',
        }),
      1000,
    );
  });
}

export function signIn(request: SignInRequestType): Promise<UserResponseType> {
  const credentials = {
    username: process.env.REACT_APP_USERNAME ?? 'admin',
    password: process.env.REACT_APP_PASSWORD ?? 'pfiadmin',
  };
  return new Promise((resolve: (value: PromiseLike<UserResponseType> | UserResponseType) => void, reject) => {
    setTimeout(() => {
      if (request.user.username === credentials.username && request.user.password === credentials.password) {
        resolve({
          username: request.user.username,
        });
      }
      reject({ status: 401, ok: false, statusText: 'Unauthorized' });
    }, 1000);
  });
}
